<template>
  <div class="group-setup">
    <v-card>
      <v-card-title dark>
        <h3 class="ma-2  orange--text">Project Status</h3>
      </v-card-title>
      <v-divider color="orange"></v-divider>
      <v-row>
        <v-col cols="12 ma-3" v-if="data && data.status">
          <v-chip small class="mr-1">{{
            stringFormatting(data.status)
          }}</v-chip>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" sm="12">
          <StatusListGrid :statusLogs="data.statusLogs"></StatusListGrid>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import StatusListGrid from "../child/StatusListGrid";
export default {
  name: "StatusList",
  props: ["data"],
  components: { StatusListGrid },

  data: () => ({}),

  mounted() { },

  methods: {
    stringFormatting(str) {
      return str.replace(/_/g, " ");
    },
  },
};
</script>
